import React, { useContext } from 'react';
import { type RestSimpleChipImagesLaCard } from '@bbkAdminUtils/api-client/rest-la-cards-types';
import { cs } from '@bbkAdminUtils/css-utils';
import CustomerHtml from '@bbkFunnel/components/customer_html/customer_html';
import { FunnelContext } from '@bbkFunnelComponents/FunnelContext';
import { LossGridItem } from '@bbkFunnelComponents/loss/sections/grid-item';
import { LossTitle } from '@bbkFunnelComponents/loss/sections/title';
import { makeClassNameSafe } from '@bbkFunnelUtils/utils';

import './loss-simple-chip-images.scss';

type Props = {
  card: RestSimpleChipImagesLaCard;
  onClick?: () => void;
};
const LossSimpleChipImages: React.FC<Props> = ({
  card,
  card: {
    requires: { title, pics },
  },
  onClick,
}) => {
  const { isPreview } = useContext(FunnelContext);
  const listItems = pics.map((item) => (
    <div className="list-pic-item" key={item.label}>
      <div className="li-image">
        <img src={item.href} alt={item.label} />
      </div>
      <div className="li-label">{item.label}</div>
    </div>
  ));
  return (
    <LossGridItem
      classes={cs('bbk-loss-simple-chip-images', makeClassNameSafe(card.name))}
      onClick={isPreview ? onClick : () => undefined}
    >
      <LossTitle>
        <CustomerHtml value={title} />
      </LossTitle>
      <div className="bbk-loss-simple-chip-images-inner">
        <div className="list-images">{listItems}</div>
      </div>
    </LossGridItem>
  );
};

export default LossSimpleChipImages;
